import { useEffect, useState } from "react";
import { databases, DATABASE_ID, COLLECTIONS } from "../lib/appwriteClient";
import { Query } from "appwrite";
import { EventCard } from "./EventCard";
import { Calendar } from "lucide-react";

export function EventsSection() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await databases.listDocuments(
        DATABASE_ID,
        COLLECTIONS.EVENTS,
        [Query.equal("is_active", true), Query.orderAsc("order")],
      );

      setEvents(response.documents || []);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="events" className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto text-center">
          <div className="animate-pulse">Loading events...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="events" className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 from-[#00b477] to-[#007a55] px-4 py-2 rounded-full mb-4">
            <Calendar className="w-5 h-5" />
            <span className="font-semibold">Event Details</span>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Competitions
          </h2>

          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Explore the exciting games and challenges we have prepared for you
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {events.map((event) => (
            <EventCard key={event.$id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}
